import axios from 'axios';
import { CalculationStatus } from '../types/calculation-status.type';

// GET
// /ewosapi/v1/planandprognosis/company/{globalCompanyId}/calculationstatus
export const getCompanyCalculationStatus = async (globalCompanyId: string): Promise<CalculationStatus> => {
  const res = await axios.get<CalculationStatus>(`/ewosapi/v1/planandprognosis/company/${globalCompanyId}/calculationstatus`);
  return res.data;
};
